import { render, staticRenderFns } from "./index_liff.vue?vue&type=template&id=c54cb914&"
import script from "./index_liff.vue?vue&type=script&lang=js&"
export * from "./index_liff.vue?vue&type=script&lang=js&"
import style0 from "./index_liff.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports